/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiPublicBranchServices200, GetApiPublicBranchServicesQueryParams, GetApiPublicBranchServicesQueryResponse } from "../entities/GetApiPublicBranchServices";
import { modelsPublicServicesOutputSchema } from "./models/publicServicesOutputSchema";
import { z } from "zod/v4";

export const getApiPublicBranchServicesQueryParamsSchema = z.object({
    "branch_id": z.coerce.number().int().min(1).describe("ID филиала")
    }) as unknown as z.ZodType<GetApiPublicBranchServicesQueryParams>

/**
 * @description OK
 */
export const getApiPublicBranchServices200Schema = z.lazy(() => modelsPublicServicesOutputSchema) as unknown as z.ZodType<GetApiPublicBranchServices200>

export const getApiPublicBranchServicesQueryResponseSchema = z.lazy(() => getApiPublicBranchServices200Schema) as unknown as z.ZodType<GetApiPublicBranchServicesQueryResponse>